import { PageSection } from '../PageSection/PageSection';
import { HoverWrapper } from '@kingspan/design-system-components';
import { alpha, useTheme, Grid, Stack, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import IconButton from '@mui/material/IconButton';
import { ReactElement, MouseEvent } from 'react';

interface AddOnHoverPanelProps {
  onClick: (event: MouseEvent<HTMLElement>) => void;
  titleText: string;
  captionText: string;
}

export function AddOnHoverPanel({ onClick, titleText, captionText }: AddOnHoverPanelProps): ReactElement {
  const theme = useTheme();

  return (
    <HoverWrapper defaultBorder="lightgrey dotted 2px" defaultBorderWidth="2px">
      <PageSection
        onClick={onClick}
        variant={'outlined'}
        sx={{ border: 'none', boxShadow: 'none', height: '300px', display: 'flex', justifyContent: 'center' }}
      >
        <Grid item xs={4} display="flex" justifyContent="center" alignItems="center">
          <Stack display="flex" justifyContent="center" alignItems="center" spacing={2}>
            <IconButton className="primaryButton" data-testid="add-standard-button" onClick={onClick}>
              <AddIcon style={{ color: 'white' }} />
            </IconButton>
            <Typography textAlign="center" variant="h6" fontFamily="KingspanBrownTT-Bold">
              {titleText}
            </Typography>
            <Typography textAlign="center" variant="body2" color={alpha(theme.palette.common.black, 0.6)}>
              {captionText}
            </Typography>
          </Stack>
        </Grid>
      </PageSection>
    </HoverWrapper>
  );
}
